import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthType } from "@intelligentlilli/api-layer";

export type UserType = {
  authData?: AuthType;
};

const initialState: UserType = {};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(_state, action: PayloadAction<AuthType>) {
      return { authData: action.payload };
    },
    updateUser(state, action: PayloadAction<AuthType>) {
      return { authData: { ...(state?.authData || {}), ...action.payload } };
    },
  },
});

export const { setUser, updateUser } = userSlice.actions;
export default userSlice.reducer;
